// A gate a developer keeps while shipping a feature and takes away once it is out, so a rollout only
// withholds and never grants. The client is never told one by name, because anything we can say
// "you have this" about is a Permission or a ClientSetting instead.
// Defined on the backend in App\Security\Access\Rollouts.
export enum Rollout {
  BrillianceV2 = 'rollout.metrics.brillianceV2',
  BrilliantStory = 'rollout.movies.brilliantStory',
  ComparisonQualityControl = 'rollout.comparison.qualityControl',
  CrowdSurvey = 'rollout.surveys.crowd',
  CustomGradeProducts = 'rollout.products.customGrade',
  Drive = 'rollout.drive.access',
  IntegralV2 = 'rollout.metrics.integralV2',
  Multistage = 'rollout.projects.multistage',
  ProductClarityBasis = 'rollout.products.clarityBasis',
  RoughColorGrading = 'rollout.grading.roughColor',
  Scintillation = 'rollout.metrics.scintillation',
  SweetLine = 'rollout.projects.sweetLine',
}
